import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, formatError } from "../../lib/api";

export const AccountPanel = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/update-credentials", {
        current_password: currentPassword,
        new_email: newEmail,
        new_password: newPassword,
      });
      toast.success(`Credenciales actualizadas. Nuevo correo: ${data.email}`);
      setCurrentPassword("");
      setNewEmail("");
      setNewPassword("");
    } catch (e2) {
      toast.error(formatError(e2));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-sand border border-clay/20 rounded-2xl px-5 py-4 text-sm text-ink placeholder:text-stone/50 focus:outline-none focus:border-clay transition-colors";
  const labelCls = "block text-[11px] uppercase tracking-[0.3em] text-stone mb-2";

  return (
    <div data-testid="account-panel" className="max-w-md">
      <div className="bg-cream border border-clay/15 rounded-3xl p-8">
        <div className="flex items-center gap-3 text-clay">
          <KeyRound size={20} strokeWidth={1.5} />
          <p className="text-[11px] uppercase tracking-[0.3em]">Cambiar credenciales</p>
        </div>
        <p className="mt-3 text-sm text-stone leading-relaxed">
          Actualiza el correo y la contraseña del panel. El cambio aplica de inmediato en todos los entornos donde uses
          esta base de datos.
        </p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className={labelCls}>Contraseña actual</label>
            <input
              data-testid="account-current-password-input"
              type="password"
              required
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className={inputCls}
            />
          </div>
          <div>
            <label className={labelCls}>Nuevo correo</label>
            <input
              data-testid="account-new-email-input"
              type="email"
              required
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              className={inputCls}
            />
          </div>
          <div>
            <label className={labelCls}>Nueva contraseña (mín. 8 caracteres)</label>
            <input
              data-testid="account-new-password-input"
              type="password"
              required
              minLength={8}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className={inputCls}
            />
          </div>
          <button
            data-testid="account-update-submit"
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-clay text-cream py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-clay-deep transition-colors disabled:opacity-60"
          >
            {loading ? "Guardando…" : "Guardar cambios"}
          </button>
        </form>
      </div>
    </div>
  );
};
